import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AuditingService } from '../../services/auditing.service';
import { AnalyticsReportModel } from '../../models/analyticsReport.model';
import { AnalyticsUsersReportModel } from '../../models/analyticsUsersReport.model';
import { AnalyticsCountryModel } from '../../models/analyticsCountryModel';
import { saveAs } from 'file-saver';
import { DatePipe, formatDate } from '@angular/common';
import { UserPermissionService } from '../../services/userPermissions.service';
import { Router } from '@angular/router';
import { severitymessage, LanguageConstants, DateFormatConstants } from 'src/app/shared-components/constant';
import { ErrorPopUpModel } from 'src/app/models/errorpopup.model';
import { MessageService } from 'primeng/api';
import { CountryService } from 'src/app/services/country.service';
import { RegionsEnum } from './../../enums/regions.enum';
import { InfraService } from 'src/app/services/infra.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { LanguageHelperService } from 'src/app/services/language.helper.service';
import { environment } from '../../../environments/environment';
import { AppConfigurationService } from './../../services/appConfiguration.service';
import { AppConfigurationsModel } from './../../models/appConfigurations.model';
import { Observable } from 'rxjs';
import { Table } from 'primeng/table';
import { format } from 'date-fns';

@Component({
  standalone: false,
  selector: 'app-analytics-report',
  templateUrl: './analytics-report.component.html',
  styleUrls: ['./analytics-report.component.css']
})
export class AnalyticsReportComponent implements OnInit {
  public canAccessAnalyticsReport = false;
  public countryList: AnalyticsCountryModel[];
  public selectedInfraId = localStorage.getItem('selectedInfra');
  public infra = this.selectedInfraId.split(',');
  public infraId = this.infra[2];
  public loggedinCountryId = +this.infra[0];
  public analyticsData: AnalyticsReportModel[];
  public analyticsUsersData: AnalyticsUsersReportModel[];
  isEngagementReadOnly: boolean = false;
  public loadspinner = false;
  public isSelectAll = false;
  public errorModel: ErrorPopUpModel = new ErrorPopUpModel();
  public confirmdisplay = false;
  public isAnalyticsReportDownloaded = false;
  public showDatabookReport = true;
  public showUserReport = false;
  public showReactivateScreen = false;
  public fromDate: Date = new Date();
  public toDate: Date = new Date();
  public minDate: Date = new Date(1900, 0, 1);
  public maxDate: Date = new Date(3000, 11, 31);
  public dateFormater: string;
  public databookToggle = true;
  public userReportToggle = false;
  public userEngReportToggle = false;
  public reactivateToggle = false;
  tabIndex: number = 0;
  langCode: string;
  currLangTranslation: any;
  isUserEngagementReportDownloaded = false;
  canAccessUserEngagementReport = false;
  public pagerows: number;
  @ViewChild('dt', { static: true }) private _table: Table;

  constructor(private auditingService: AuditingService, private userPermissionService: UserPermissionService, private router: Router,
    private countryService: CountryService, private infraService: InfraService, private messageService: MessageService,
    private translateService: TranslateService, private elemRef: ElementRef,  private appConfigService: AppConfigurationService,
    private languageHelper: LanguageHelperService, public datepipe: DatePipe) {
    this.fromDate.setMonth(this.fromDate.getMonth() - 1);
    this.isEngagementReadOnly = this.appConfigService.GetConfigValueByKey("IsProjectsReadOnly");
    this.infraService.infraDetails$.subscribe((data) => {
      if (data !== undefined) {
        if (data.InfraId !== RegionsEnum.US) {
          this.dateFormater = 'dd/mm/yy';
        } else {
          this.dateFormater = 'mm/dd/yy';
        }
      }
    });
  }

  ngOnInit() {
    this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
    this.currLangTranslation = this.translateService.translations[this.langCode];
    this.pagerows = environment.pageRows25;
    this.translateService.onLangChange.subscribe((langEvent: LangChangeEvent) => {
      this.langCode = langEvent.lang;
      this.currLangTranslation = langEvent.translations;
      var elems = this.elemRef.nativeElement.getElementsByClassName('p-tabview-nav-link');
      if (elems.length) {
        elems[0].innerText = this.currLangTranslation.analyticsReport.Daily;
        elems[1].innerText = this.currLangTranslation.analyticsReport.Weekly;
        elems[2].innerText = this.currLangTranslation.analyticsReport.Monthly;
        elems[3].innerText = this.currLangTranslation.analyticsReport.Daily;
        elems[4].innerText = this.currLangTranslation.analyticsReport.Weekly;
        elems[5].innerText = this.currLangTranslation.analyticsReport.Monthly;
      }
      this.checkUserCanccessAnalyticsReport();
    });

    this.checkUserCanccessAnalyticsReport();
    this.checkUserCanAccessUserEngReport();
  }

  getDatabookReport() {
    this.databookToggle = true;
    this.showDatabookReport = true;
    this.showUserReport = false;
    this.userReportToggle = false
    this.showReactivateScreen = false;
    this.reactivateToggle = false;
    this.userEngReportToggle = false;
  }

  getUserReport() {
    this.databookToggle = false;
    this.showDatabookReport = false;
    this.showUserReport = true;
    this.userReportToggle = true;
    this.showReactivateScreen = false;
    this.reactivateToggle = false;
    this.userEngReportToggle = false;
  }

  downloadUserEngagementReport() {
    this.userEngReportToggle = true;
    this.isUserEngagementReportDownloaded = this.loadspinner = true;
    this.auditingService.getUserEngagememtDataExcel().subscribe(blobData => {
      this.loadspinner = this.isUserEngagementReportDownloaded = false;
      if (blobData) {
        saveAs(blobData, 'UserEngagementReport_' + formatDate(new Date(), 'MMddyyyy', 'en') + '.xlsx');
        this.messageService.add({
          key: severitymessage.key, severity: severitymessage.success
          , summary: this.currLangTranslation.severitymessage.notification, detail: this.currLangTranslation.analyticsUsersReport.UserEngagementReportDownloaded, sticky: true, closable: true
        });
      } else {
        this.messageService.add({
          key: severitymessage.key, severity: severitymessage.error
          , summary: this.currLangTranslation.severitymessage.notification, detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
        });
      }
    }, err => {
      this.loadspinner = this.isUserEngagementReportDownloaded = false;
      this.messageService.add({
        key: severitymessage.key, severity: severitymessage.error
        , summary: this.currLangTranslation.severitymessage.notification, detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
      });
    });
  }

  getReactivateScreen() {
    this.databookToggle = false;
    this.showDatabookReport = false;
    this.showUserReport = false;
    this.userReportToggle = false
    this.showReactivateScreen = true;
    this.reactivateToggle = true;
    this.userEngReportToggle = false;
  }

  private checkUserCanccessAnalyticsReport() {
    this.loadspinner = true;
    this.userPermissionService.canAccessAnalyticsReport().subscribe((response: any) => {
      this.canAccessAnalyticsReport = response;
      if (this.canAccessAnalyticsReport) {
        this.getAnalticsData();
        this.getcountrylist();
      } else {
        this.loadspinner = false;
        this.router.navigate(['unauthorize'], { queryParams: { redirectFrom: 'analytics-report' } });
      }
    },
      error => {
        this.loadspinner = false;
      });
  }

  private checkUserCanAccessUserEngReport() {
    if (environment.env === 'prod') {
      this.userPermissionService.canAccessUserEngReport().subscribe((response: any) => {
        this.canAccessUserEngagementReport = response;
      },
        error => {
          this.canAccessUserEngagementReport = false;
        });
    } else {
      this.canAccessUserEngagementReport = true;
    }
  }

  private getAnalticsData(): void {
    this.auditingService.getAnalyticsData().subscribe((data: AnalyticsReportModel[]) => {
      this.analyticsData = data;
      this.loadspinner = false;
      this.analyticsData.forEach((x) => {
        if (x.countryId === this.loggedinCountryId) {
          x.IsDisplay = true;
        }

        if(x.groupByName === 'Daily'){
          x.groupByValue = this.languageHelper.convertDateToLocale(this.langCode, x.groupByValue, DateFormatConstants.DEFAULT_FORMAT);
        }
        else if(x.groupByName === 'Weekly'){
          x.groupByValue = this.languageHelper.convertDateToLocale(this.langCode, x.groupByValue.substring(0,11), DateFormatConstants.DEFAULT_FORMAT2) + ' - '+
          this.languageHelper.convertDateToLocale(this.langCode, x.groupByValue.substring(0,11), DateFormatConstants.DEFAULT_FORMAT2)

        }
        else if(x.groupByName === 'Monthly'){
          x.groupByValue = this.languageHelper.convertDateToLocale(this.langCode, x.groupByValue, DateFormatConstants.MONTHYEAR);
        }

      });
    });
    this.getUsersAnalyticsData();
  }

  private getcountrylist(): void {
    this.countryService.getcountrylist().subscribe((data: AnalyticsCountryModel[]) => {
      this.countryList = data.map(s => ({
        Id: s.Id,
        Country: s.Country,
        InfraId: s.InfraId,
        IsChecked: false
      }));

      this.countryList = this.countryList.filter(x => x.Country !== 'Select');
      this.countryList = this.countryList.filter(x => x.InfraId === parseInt(this.infraId));
      this.countryList.forEach((x) => {
        if (x.Id === this.loggedinCountryId) {
          x.IsChecked = true;
        }
      });
    });
  }

  public getAnalyticsBasedOnCountryChange(countryId: any, event: any) {
    this.loadspinner = true;
    this.analyticsData.forEach((x) => {
      if (x.countryId === countryId) {
        if (event.currentTarget.checked) {
          x.IsDisplay = true;
        } else if (!event.currentTarget.checked) {
          x.IsDisplay = false;
        }
      }
    });

    if (!event.currentTarget.checked) {
      this.isSelectAll = false;
    } else {
      this.isSelectAll = (this.countryList.every(ad => ad.IsChecked === true)) ? true : false;
    }
    this.loadspinner = false;
  }

  public getAnalyticsDataExcel() {
    event.stopPropagation();
    const selectedCountry = this.getSelectedCountryList();
    if (!selectedCountry) {
      this.errorModel.confirmIsDisplay = true;
      this.errorModel.displayMessage = this.currLangTranslation.analyticsReport.ErrorMessage.NoCountrySelectedError;
      return;
    }
    this.isAnalyticsReportDownloaded = this.loadspinner = true;
    this.auditingService.getAnalyticsDataExcel(selectedCountry, this.langCode).subscribe(blobData => {
      this.loadspinner = this.isAnalyticsReportDownloaded = false;
      if (blobData) {
        saveAs(blobData, 'AnalyticsReport_' + formatDate(new Date(), 'MMddyyyy', 'en') + '.xlsx');
        this.messageService.add({
          key: severitymessage.key, severity: severitymessage.success
          , summary: this.currLangTranslation.severitymessage.notification, detail: this.currLangTranslation.severitymessage.AnalyticsReportDownloaded, sticky: true, closable: true
        });
      } else {
        this.messageService.add({
          key: severitymessage.key, severity: severitymessage.error
          , summary: this.currLangTranslation.severitymessage.notification, detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
        });
      }
    }, err => {
      this.loadspinner = this.isAnalyticsReportDownloaded = false;
      this.messageService.add({
        key: severitymessage.key, severity: severitymessage.error
        , summary: this.currLangTranslation.severitymessage.notification, detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
      });
    });
  }

  public getUsersAnalyticsDataExcel() {
    event.stopPropagation();
    if (this.toDate < this.fromDate) {
      this.errorModel.confirmIsDisplay = true;
      this.errorModel.displayMessage = this.currLangTranslation.analyticsReport.ErrorMessage.DateValidationError;
      this.loadspinner = false;
      return;
    }
    this.isAnalyticsReportDownloaded = this.loadspinner = true;
    //const fromDate = moment(this.fromDate).format('YYYY-MM-DD');
    //const toDate = moment(this.toDate).format('YYYY-MM-DD');
    const fromDate = format(new Date(this.fromDate), "yyyy-MM-dd");
    const toDate = format(new Date(this.toDate), "yyyy-MM-dd");

    this.auditingService.getUsersAnalyticsDataExcel(fromDate, toDate, this.langCode).subscribe(blobData => {
      this.loadspinner = this.isAnalyticsReportDownloaded = false;
      if (blobData) {
        saveAs(blobData, 'UsersAnalyticsReport_' + formatDate(new Date(), 'dd-MMM-yyyy', 'en') + '.xlsx');
        this.messageService.add({
          key: severitymessage.key, severity: severitymessage.success
          , summary: this.currLangTranslation.severitymessage.notification, detail: this.currLangTranslation.severitymessage.UsersAnalyticsReportDownloaded, sticky: true, closable: true
        });
      } else {
        this.messageService.add({
          key: severitymessage.key, severity: severitymessage.error
          , summary: this.currLangTranslation.severitymessage.notification, detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
        });
      }
    }, err => {
      this.loadspinner = this.isAnalyticsReportDownloaded = false;
      this.messageService.add({
        key: severitymessage.key, severity: severitymessage.error
        , summary: this.currLangTranslation.severitymessage.notification, detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
      });
    });
  }

  public closeEventErrorModal($event: any) {
    this.confirmdisplay = $event;
  }

  public selectAllCountry() {
    this.loadspinner = true;
    this.countryList.forEach((cl: AnalyticsCountryModel) => {
      cl.IsChecked = (this.isSelectAll) ? true : false;
      const analyticsData: AnalyticsReportModel[] = this.analyticsData.
        filter((ad: AnalyticsReportModel) => (ad.countryName === cl.Country));
      if (analyticsData.length) {
        analyticsData.forEach((al: AnalyticsReportModel) => al.IsDisplay = cl.IsChecked);
      }
    });
    this.loadspinner = false;
  }

  private getSelectedCountryList(): string {
    let selectedCountry = '';
    const selectedCountryList = this.countryList.filter((cl: AnalyticsCountryModel) => (cl.IsChecked));
    if (selectedCountryList.length) {
      selectedCountryList.forEach((cl: AnalyticsCountryModel) => {
        selectedCountry = selectedCountry.concat(String(cl.Id) + ',');
      });
      selectedCountry = selectedCountry.substring(0, selectedCountry.length - 1);
    }
    return selectedCountry;
  }

  public getUsersAnalyticsBySearch() {
    this.getUsersAnalyticsData();
  }

  public getUsersAnalyticsData() {
    const fromDate = format(new Date(this.fromDate), "yyyy-MM-dd");
    const toDate = format(new Date(this.toDate), "yyyy-MM-dd");
    this.loadspinner = true;

    if (this.toDate < this.fromDate) {
      this.errorModel.confirmIsDisplay = true;
      this.errorModel.displayMessage = this.currLangTranslation.analyticsReport.ErrorMessage.DateValidationError;
      this.loadspinner = false;
      return;
    }

    this.auditingService.getUsersAnalyticsData(fromDate, toDate).subscribe((data: AnalyticsUsersReportModel[]) => {
      this.analyticsUsersData = data;
      this.analyticsUsersData.forEach((x) => {
          x.dateTranslated = this.languageHelper.convertDateToLocale(this.langCode, this.datepipe.transform(x.date, DateFormatConstants.DEFAULT_FORMAT), DateFormatConstants.DEFAULT_FORMAT);
        });

      this.loadspinner = false;
    });
  }

  // For GDS & NON-GDS tabs change
  tabChange(e: any) {
    this.tabIndex = e.index;
  }
}
